import React from "react";
import styled from "styled-components";
import { Route, Routes } from "react-router-dom";

import PageTitle, { HeadProvider } from "../../ui-components/PageTitle";

import { GlobalStyle } from "./components/GlobalStyle";
import { Loading } from "./components/Loading";

const EditorView = React.lazy(
  async () => import(/* webpackChunkName: 'dashboard' */ "../editor/EditorView")
);

const NotFoundView = React.lazy(
  async () =>
    import(/* webpackChunkName: 'not-found' */ "./components/NotFound")
);

const Application = () => (
  <HeadProvider>
    <GlobalStyle />
    <PageTitle />
    <Body>
      <React.Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/" element={<EditorView />} />
          <Route path="*" element={<NotFoundView />} />
        </Routes>
      </React.Suspense>
    </Body>
  </HeadProvider>
);

export default Application;

const Body = styled.main`
  display: flex;
  flex: 1;
  position: relative;
  margin: 0 auto;
  padding: 0 32px;
  width: 1096px;
  max-width: 100%;

  .full-width & {
    width: 100%;
  }
`;
